import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { ActivatedRoute, Router } from "@angular/router";
import { EditChiefuserComponent } from "@app/features-modules/chief-accountant/components/edit-chiefuser/edit-chiefuser.component";
import { JoinMeetingComponent } from "@app/features-modules/client/components/join-meeting/join-meeting.component";
import { EditOrgnizationComponent } from "@app/features-modules/superadmin/components/edit-orgnization/edit-orgnization.component";
import { EditUserComponent } from "@app/features-modules/superadmin/components/edit-user/edit-user.component";
import { environment } from "@env/environment";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { ConfirmDialogComponent, DialogData } from "@shared/confirm-dialog/confirm-dialog.component";
import { ComponentType } from "@shared/constants/component-types";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import { CommonService } from "@shared/services/common.service";
import storageService from "@shared/storage/storageService";
import moment from "moment";
import { ToastrService } from "ngx-toastr";
import { filter, takeUntil } from "rxjs/operators";
import { Status } from '../../../../assets/constant';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AuthenticationResult, BrowserUtils, InteractionStatus, PopupRequest } from "@azure/msal-browser";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { resolve } from "dns";
import { checkServerIdentity } from "tls";
import { Day } from "@syncfusion/ej2-angular-schedule";
import { MyClientComponent } from "@app/features-modules/accountant/my-client/my-client.component";
import { AppointmentRequestComponent } from "@app/features-modules/accountant/appointment-request/appointment-request.component";
import { EditAccuserComponent } from "@app/features-modules/chief-accountant/components/edit-accuser/edit-accuser.component";
import { Console } from "console";
import { Placeholder } from "@angular/compiler/src/i18n/i18n_ast";
import { CaAppointmentRequestComponent } from "@app/features-modules/chief-accountant/ca-appointment-request/ca-appointment-request.component";
import { CaEvaluationFeedbackComponent } from "@app/features-modules/chief-accountant/ca-evaluation-feedback/ca-evaluation-feedback.component";
import { ImportFileComponent } from "@app/features-modules/superadmin/components/import-file/import-file.component";
import { CaImportFeedbackPdfComponent } from "@app/features-modules/chief-accountant/ca-import-feedback-pdf/ca-import-feedback-pdf.component";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent implements OnInit {
  @Input()
  public data!: any[];

  @Input()
  public totalAverageRatings: any[];

  exportData: any;
  
  @Input()
  public totalRecords!: any;

  totalAverageRating: any

  @Input()
  public filterBy!: any;

  @Input()
  public filterValue!: any;

  @Input()
  public visible = true;

  @Input()
  public cols!: any[];

  toggle: boolean;

  @ViewChild("toggleElement") ref: ElementRef;

  @Output()
  stepClick = new EventEmitter<any>();

  @Output() loadFeed = new EventEmitter<any>();
  @Output() loadExportData = new EventEmitter<any>();

  @Output() loadAverageRatings = new EventEmitter<any>();
  @Output() loadAverageRatingsAcc = new EventEmitter<any>();

  @Output() clearFilterEnable = new EventEmitter<any>();
  @Output() toogleType = new EventEmitter<any>();
  @Output() feedbackRequest = new EventEmitter<any>();
  @Output() changeSelectedUsers = new EventEmitter<any>();
  selUsersNewData : any = [];

  subscription: any;
  isComponent: any;
  selectedLanguage = "";
  dialogRef: any;
  usercaseIdAndStatus: any = {};
  
  isEditEnabled: boolean = false;
  isDeleteEnabled: boolean = false;
  currentUser: any;
  loading: boolean;
  currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  public dataToDelete: any;
  blob: Blob;
  test1: number = 9;
  message: any;
  deleteSuccess: any;
  join: any;
  deleteUserToaster: any;
  allText: any;
  createToaster: any;
  deleteMessage: any;
  isloadFirstTime = false;
  loadFirstTimeII = false;
  isInputFocused = true;
  userExchangeUserName: any;
  userExchangePassword: any;
  userOutlookUsername : any;
  userOutlookPassword: any;
  private readonly _destroying$ = new Subject<void>();
  outlookData: any;
  isExportData = false;
  showPopUp: boolean =  false;
  cloneTableData: any;
  searchTerm = ''
  showPlaceholder = true;
  showSpinner: boolean;
  appointmentActive : boolean;
  empSatisfactionActive : boolean;
  customerFeedbackActive : boolean ;
  selectedUsers: any[] = [];
  feedbackReqestData: any[];
  isSelected: any;
  myClientFeedbackData: any[];
  allClientData: any[];
  myClientData: any[];
  fliterMyClientData = false;
  cloneCustdata: any[];
  type: any = 1;
  accName: any;
  currentPage: number = 0;

  constructor(
    private broadCast: BroadCastServiceService,
    private commonService: CommonService,
    private auth: ApiCall,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private router: Router,
    public translate: TranslateService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private location: Location,
    private apiCall: ApiCall,
    private cd : ChangeDetectorRef,
    private route : ActivatedRoute
    
  ) {
  }

  ngOnInit() {
    this.setLanguage();
    this.isComponent = this.commonService.isComponent;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.setUserCalendarAccounts();
    
    this.totalAverageRating = 0
    this.loadData(null)
    this.employeeFeedBackDropDown();
    this.titleFeedBackDropDown();
    this.custFilterFeedbackDropdown();
    this.toggleFeedbackData();
    this.broadCast.getSubFeedReq().subscribe((message) => {
      if(message) {
        this.selectedUsers = []
        this.changeSelectedUsers.emit({ event: true, data: this.selectedUsers });
      }
    });

    this.route.queryParams.subscribe(params => {
      const pageParam = +params['page'];
      this.currentPage = isNaN(pageParam) ? 0 : pageParam;
    })

  }

onPageChange(event: any) {
  const page = event.first / event.rows; // Convert offset to page index
  this.currentPage = page;

  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { page: this.currentPage },
    queryParamsHandling: 'merge',
  });
}


  getAllAccountantOutlookEvent() {  
    return new Promise((resolve,reject) => {
      this.auth.getAccountantOutlookEvents().subscribe((res) => {
        this.outlookData = {'data' : 'null'};
        let recurrData:any;
        if (res.value.length != 0) {
          res.value.forEach(ele => {
            if(ele.recurrence != null) {
              var dateStart = new Date(ele.recurrence.range.startDate);
              var start = moment(new Date(dateStart.getTime())).format('YYYY-MM-DD');
              var dateEnd = new Date(ele.recurrence.range.endDate);
              var end = moment(new Date(dateEnd.getTime() +(1 *86400000))).format('YYYY-MM-DD');
  
              this.getOutLookRecurrenceData(start,end).then(value => {
              recurrData = this.convertRecuurenceOutlookEvent(value,ele.subject,ele.bodyPreview,ele.location);
              });
            }
          });
          this.outlookData = [];
          this.outlookData = this.convertOutlookEvent(res.value);
          setTimeout(() => {
            let newArr = [];
            let tempDataCommonRecord: any;
            let newVar: any;
            if(recurrData) {
              recurrData.bookingSlots.forEach(obj => {
                tempDataCommonRecord = this.outlookData.bookingSlots.find(c => c.subject === obj.subject);
              });
              if(tempDataCommonRecord) {
                newVar = recurrData.bookingSlots.find((word) => (this.isDatesEqual(word.slotStartTime,tempDataCommonRecord.slotStartTime)) && (this.isDatesEqual(word.slotEndTime,tempDataCommonRecord.slotEndTime)));
              }
              if(newVar === undefined) {
                let index = this.outlookData.bookingSlots.findIndex( c => c.subject === tempDataCommonRecord.subject);
                if (index !== -1) {
                  this.outlookData.bookingSlots.splice(index,1);
                }
              }
              newArr = recurrData.bookingSlots.concat(this.outlookData.bookingSlots);
  
            } else {
              newArr = this.outlookData.bookingSlots;
            }
            newArr.forEach(element => {
              element.slotStartTime = element.slotStartTime
              element.slotEndTime = element.slotEndTime;
            });
            var result = newArr.reduce((unique, o) => {
              if(!unique?.some(obj => (this.isDatesEqual(obj.slotStartTime,o.slotStartTime)) && (this.isDatesEqual(obj.slotEndTime,o.slotEndTime)))) {
                unique.push(o);
              }
              return unique;
          },[]);
          let requestBody: any = {
          }
          requestBody.bookingSlots = result;
          this.outlookData = result;
          resolve(this.outlookData);
          },10);
        } else {
          this.outlookData = null;
          resolve(true);
        }
          }, (error) => {
        console.error("Error , ", error);
      });
    })
  }

  convertRecuurenceOutlookEvent(recOutLookData,sub,bodyPreview,location) {
  
    let requestBody: any = {
    }
    let bookingSlots: any[] = [];
    recOutLookData.forEach((element,i) => {
        let finalStartTime = moment.utc(element.start.dateTime).toDate();
        let finalEndTime = moment.utc(element.end.dateTime).toDate();
        let bookingSlot = {
          slotStartTime: finalStartTime,
          slotEndTime: finalEndTime,
          subject: sub,
          description: bodyPreview,
          meetingLink: location.displayName,
          outlookSlot: true,
          venaqiSlot: false,
          exchangeSlot: false
        };
        if(element.type == 'occurrence') {
          bookingSlots.push(bookingSlot);
        }
    });
    requestBody.bookingSlots = bookingSlots;
    return requestBody;
}


  convertOutlookEvent(outlookData) {
    try {
      let requestBody: any = {
      }
      let bookingSlots: any[] = [];
      outlookData.forEach(element => {
        let finalStartTime = moment.utc(element.start.dateTime).toDate();
        let finalEndTime = moment.utc(element.end.dateTime).toDate();
        let bookingSlot = {
          slotStartTime: finalStartTime,
          slotEndTime: finalEndTime,
          subject: element.subject,
          description: element.bodyPreview,
          meetingLink: element.location.displayName,
          outlookSlot: true,
          venaqiSlot: false,
          exchangeSlot: false
        };
        bookingSlots.push(bookingSlot);
      })
      requestBody.bookingSlots = bookingSlots;
      return requestBody;
    } catch (error) {
      console.error("Error while preparing outlook request body, ", error);
    }
  }

  isDatesEqual(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate() && date1.getTime() === date2.getTime();
  }

  getOutLookRecurrenceData(startDate,endDate) {
    return new Promise(resolve => {
        this.auth.getOutLookCal(startDate,endDate).subscribe((res) => {
          if(res.value.length != 0) {
            resolve(res.value);
          }
        });
    });

  }

  getAllText() {
    this.translate.get(['ALL_TEXT'])
      .subscribe(translations => {
        this.allText = translations['ALL_TEXT'];
      });
    return this.allText;
  }

  setLanguage() {
    this.selectedLanguage = storageService.getItem("language");
    this.translate.use(this.selectedLanguage);
  }

  openJoinModel(data) {
    try {
      const meetingLink = data.bookingSlot.accountantBookingSlot.meetingLink;
      window.open(meetingLink, '_blank');
    } catch (error) {
      console.error("Error occurred while opening the meeting link, ", error);
    }
  }

  /**
   * This function decides whether to show/hide the 'Join now button' 
   * @param data Data of the particular meeting
   * @returns Whether to show/hide the 'Join now' button
   */
  showJoinButton(data) {
    try {
      if(data.bookingSlot) {
        const startTimeInMin = this.getTimeDifferenceInMinutes(new Date(data.bookingSlot.slotStartTime));
        const endTimeInMin = this.getTimeDifferenceInMinutes(new Date(data.bookingSlot.slotEndTime));
        if (
          (this.isComponent == 'client-appoinment'
            || this.isComponent === 'chief-Appoinment'
            || this.isComponent === 'accountant-dashboard')
          && data.userCaseStatus == 'CONFIRMED'
          && startTimeInMin < 10
          && endTimeInMin > 0
        ) {
          return true;
        }
        return false;
      }
    } catch (error) {
      console.log("Error while showing 'Join now' button, ", error);
      return false;
    }
  }

  hideJoinButton(data) {
    try {
      if(data.bookingSlot) {
        const endTimeInMin = this.getTimeDifferenceInMinutes(new Date(data.bookingSlot.slotEndTime));
        if (
          (this.isComponent == 'client-appoinment'
            || this.isComponent === 'chief-Appoinment'
            || this.isComponent === 'accountant-dashboard')
  
          && endTimeInMin < 0
        ) {
          return true;
        }
        return false;
      }
    } catch (error) {
      console.log("Error while hidining 'Join now' button, ", error);
      return false;
    }
  }

  /**
   * This function gets the time difference from current time (in minutes)
   * @param data 
   * @returns 
   */
  getTimeDifferenceInMinutes(jsDate) {
    try {
      const now = moment();

      const slotTime = moment(jsDate);
      const timeDiff = slotTime.diff(now);
      const timeDuration = moment.duration(timeDiff);
      const timeInMin = timeDuration.asMinutes();
      return timeInMin;
    } catch (error) {
      console.error("Error while getting time difference minutes, ", error);
    }
  }

  getRemainingTime(data) {
    try {
      let inText;
      this.translate.get(['P_TABlE.JOIN_TEXT'])
        .subscribe(translations => {
          this.join = translations['P_TABlE.JOIN_TEXT'];
        });
      if(data.bookingSlot) {
        const startTime: Date = new Date(data.bookingSlot.slotStartTime);
        const momentStartTime = moment(startTime);
        let fromNowString: string = this.join + " " + momentStartTime.fromNow();
        let number;
        let finalString;
        if (fromNowString.match(/\d+/g)) {
          number = fromNowString.includes("ago") ? "" : fromNowString.split((fromNowString.includes("ago") ? "" : fromNowString).match(/\d+/)[0]);
          if (number) {
            finalString = number[1].trim();
          }
        } else {
          number = momentStartTime.fromNow();
          finalString = momentStartTime.fromNow();
        }
        this.translate.get(['P_TABlE.IN_TEXT'])
          .subscribe(translations => {
            inText = translations['P_TABlE.IN_TEXT'];
          });
        let inTextSplit = fromNowString.split(' ');
        inTextSplit[1] = inTextSplit[1].replace(/in/g, inText);
        fromNowString = '';
        inTextSplit.forEach((ele) => {
          fromNowString = fromNowString + ' ' + ele;
        });
        let text;
        let temp;
        if (finalString === 'hours') {
          this.translate.get(['P_TABlE.HOURS'])
            .subscribe(translations => {
              text = translations['P_TABlE.HOURS'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
  
        } else if (finalString === 'hour') {
          this.translate.get(['P_TABlE.HOUR'])
            .subscribe(translations => {
              text = translations['P_TABlE.HOUR'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === 'min' || number[1] === 'minute') {
          this.translate.get(['P_TABlE.MIN'])
            .subscribe(translations => {
              text = translations['P_TABlE.MIN'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === 'mins' || number[1] === 'minutes') {
          this.translate.get(['P_TABlE.MINS'])
            .subscribe(translations => {
              text = translations['P_TABlE.MINS'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === 'day') {
          this.translate.get(['P_TABlE.DAY'])
            .subscribe(translations => {
              text = translations['P_TABlE.DAY'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === 'days') {
          this.translate.get(['P_TABlE.DAYS'])
            .subscribe(translations => {
              text = translations['P_TABlE.DAYS'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        }
        else if (finalString === 'month') {
          this.translate.get(['P_TABlE.MONTH'])
            .subscribe(translations => {
              text = translations['P_TABlE.MONTH'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === 'months') {
          this.translate.get(['P_TABlE.MONTHS'])
            .subscribe(translations => {
              text = translations['P_TABlE.MONTHS'];
            });
          temp = fromNowString.split(finalString);
          fromNowString = temp[0] + text;
        } else if (finalString === momentStartTime.fromNow()) {
          var testing = finalString.split(" ").splice(-2);
          if (testing[1] === 'month') {
            this.translate.get(['P_TABlE.A_MONTH'])
              .subscribe(translations => {
                text = translations['P_TABlE.A_MONTH'];
              });
          }
          if (testing[1] === 'week') {
            this.translate.get(['P_TABlE.A_WEEK'])
              .subscribe(translations => {
                text = translations['P_TABlE.A_WEEK'];
              });
          }
          if (testing[1] === 'day') {
            this.translate.get(['P_TABlE.A_DAY'])
              .subscribe(translations => {
                text = translations['P_TABlE.A_DAY'];
              });
          }
          let finalVar = fromNowString.split(' ').slice(0, 2).join(' ');
          fromNowString = finalVar + " " + text;
        }
        return fromNowString.includes("ago") || !text ? "" : fromNowString;
      }
    } catch (error) {
      console.error("Error while getting remaining time, ", error);
    }
  }

  onNameClick(data: any) {
    try {
      this.router.navigate(["client/appoinment-details"]);
      storageService.setItemAsJSON('appoinment', data);
    } catch (error) {
    }
  }

  onAccNameClick(data) {
    try {
      this.router.navigate(["accountant/acc-details"]);
      storageService.setItemAsJSON('acc-appoinment', data);
    } catch (error) {
    }
  }

  onFbNameClick(data) {
    try {
      this.router.navigate(
        ["chiefaccountant/ca-feedback-detail", data.user.id, data.feedbackId, data.user.organizationId,false],
        {
          queryParams : {page : this.currentPage}
        }
      );
    } catch (error) {
      console.log("Error while navigating to feedback details, ", error);
    }
  }

  linkedAccountantFeedback(data) {
    try {
      this.router.navigate(
        ["chiefaccountant/ca-accountant-performance-feedback", data.id]
      );
    } catch (error) {
      console.log("Error while navigating to feedback details, ", error);
    }
  }
  

  onFbAccNameClick(data,isComponent) {
    try {
      if(this.isComponent === 'acc-my-accounting-firm') {
       this.router.navigate(['accountant/accounting-firm-details',data.feedbackId,data.user.organizationId])
      } else if(this.isComponent === 'ca-employee-satisfaction') {
        this.router.navigate(['chiefaccountant/employee-satisfaction-details',data.feedbackId,data.user.organizationId])
      } else {
        this.router.navigate(
          ["accountant/acc-feedback-detail", data.user.id, data.feedbackId, data.user.organizationId,true]
        );
      }
    } catch (error) {
      console.log("Error while navigating to feedback details, ", error);
    }
  }
  onClientNameClick(data) {
    try {
      this.router.navigate(
        ["chiefaccountant/ca-feedback-detail", data.user.id, data.feedbackId, data.user.organizationId,true]
      );
    } catch (error) {
      console.log("Error while navigating to feedback details, ", error);
    }
  }
  onEyeButtonClick(data: any, isComponent: string) {
    try {
        let route: string[];
        switch (isComponent) {
            case 'acc-my-accounting-firm':
                route = ['accountant/accounting-firm-details', data.feedbackId, data.user.organizationId];
                break;
            case 'ca-employee-satisfaction':
                route = ['chiefaccountant/employee-satisfaction-details', data.feedbackId, data.user.organizationId];
                break;
            case 'ca-periodic-evaluation':
              route = ['chiefaccountant/ca-evaluation-detail', data.id, data.user.organizationId];
              break;
              case 'ca-annual-evaluation':
                route = ['chiefaccountant/ca-evaluation-detail', data.id, data.user.organizationId];
                break;
            case 'acc-my-professional-journey':
                route = ['accountant/acc-evaluation-feedback-detail', data.id, data.user.organizationId];
                break;
            case 'acc-annual-interview':
                route = ['accountant/acc-evaluation-feedback-detail', data.id, data.user.organizationId];
                break;
       
            default:
                route = ["accountant/acc-feedback-detail", data.user.id, data.feedbackId, data.user.organizationId, true];
                break;
        }
        this.router.navigate(route);
    } catch (error) {
        console.log("Error while navigating to feedback details, ", error);
    }
}

onFeebackButtonClick(data: any, isComponent: string){
  let route: string[];
  switch(isComponent){
    case 'ca-periodic-evaluation' :
      route = ['chiefaccountant/ca-evaluation-feedback',false,data.id, data.user.id, data.user.organizationId];
    break;
    case 'acc-my-professional-journey' : 
      route = ['accountant/modify-accountant-feedback',false, data.id, data.user.id, data.user.organizationId];
    break;
    case 'acc-annual-interview' : 
      route = ['accountant/modify-accountant-feedback',true, data.id, data.user.id, data.user.organizationId];
    break;
    case 'ca-annual-evaluation' :
      route = ['chiefaccountant/ca-evaluation-feedback',true ,data.id, data.user.id, data.user.organizationId];
    break;
  }
  this.router.navigate(route)
}


importPDF(data : any) {
  this.dialog.open(CaImportFeedbackPdfComponent, {
    data: {
      tempdata: data
    },
  });
}

  onCANameClick(data) {
    try {
      this.router.navigate(["chiefaccountant/ca-appoinment-detail"]);
      storageService.setItemAsJSON('ca-appoinment', data);
    } catch (error) {
      console.error("Error in fetching data", error);
    }
  }

  getFileName(data) {
    try {
      if (data.userCaseDocument && data.userCaseDocument.documentName) {
        let fileName: String = data.userCaseDocument.documentName;
        if (fileName.length > 20) {
          fileName = fileName.slice(0, 20) + "...";
        }
        return fileName;
      } else {
        return "";
      }
    } catch (error) {
      console.error("Error while getting file name, ", error);
    }
  }

  isFilePresent(data) {
    try {
      if (data.userCaseDocument) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error while checking file present', error)
    }
  }
  onFileDownload(data) {
    try {
      if (data.userCaseDocument && data.userCaseDocument.documentId) {
        this.auth.downloadDocument(data.userId, data.id, data.userCaseDocument.documentId).subscribe(
          (res) => {
            this.blob = new Blob([res], { type: 'application/pdf' });
            var downloadURL = window.URL.createObjectURL(res);
            var link = document.createElement('a');
            link.href = downloadURL;
            link.download = data.userCaseDocument.documentName;
            link.click();
            let message;
            this.translate.get(['DOCUMENT_DOWNLOADED_SUCCESS'])
              .subscribe(translations => {
                message = translations['DOCUMENT_DOWNLOADED_SUCCESS'];
              });
            this.toastr.success(message, '', {
              timeOut: 3000
            });
          },
          (err: any) => {
            console.error("Something went wrong", err);
          });
      }
    } catch (error) {
      console.error("Error to dowload document", error);
    }

  }
  onApprovedAppoinment(rowData) {
    try {
      this.usercaseIdAndStatus = {
        id: rowData.id,
        userCaseStatus: Status.Confirmed,
        clientTimeZone: this.currentTimeZone
      }
      this.loading = true;
      let comapareData = null;
      if(this.currentUser.calendarChoice !== 'MS_EXCHANGE') {
        let activeAccount;
        this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
        activeAccount = this.authService.instance.getAllAccounts().length > 0;
        });
      if (!activeAccount){
           this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
             .subscribe((response: AuthenticationResult) => {
               this.authService.instance.setActiveAccount(response.account);
               this.apiCall.setOutlookTokens(response.accessToken, response.idToken, response.tokenType);
               if(rowData) {
                this.loading = false;
                if(this.currentUser.calendarChoice !== 'MS_EXCHANGE') {
                this.getAllAccountantOutlookEvent().then(value => {
                  comapareData = this.checkInBetweenDates(rowData.bookingSlot.slotStartTime,rowData.bookingSlot.slotEndTime);
                  if(!comapareData) {
                    let outlookRequest = this.convertBookedSlotToOutlookEvent(rowData);
                    this.createSameEventOnOutlookCalendar(outlookRequest);
                    this.auth.approvedRejectAppoinment(this.usercaseIdAndStatus).subscribe(
                      (res: any) => {
                        let message;
                        let tempdata = res.data;
                        this.translate.get(['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'])
                          .subscribe(translations => {
                            message = translations['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'];
                          });
                        this.toastr.success(message, '',);
                        this.loading = false;
                        // this.openOutlookModel(tempdata);
                 
                        
                        if (this.isComponent == 'accountant-dashboard') {
                          this.broadCast.sendMessage("getListAfterDelete");
                          this.broadCast.sendMessage('accountant-dashboard');
                        }
                        if (this.isComponent == 'chief-Appoinment') {
                          this.broadCast.sendMessage("getDetailsAfterDelete");
                          this.broadCast.sendMessage('chief-account');
                        }
                      },
                      (err: any) => {
                        console.error("Something went wrong");
                      });
                  } else {
                    if(comapareData === 'inBetween') {
                      let text;
                      this.translate.get(['IN_TIME_CLASHES'])
                      .subscribe(translations => {
                        text = translations['IN_TIME_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    } else if(comapareData === 'startTime') {
                      let text;
                      this.translate.get(['START_CLASHES'])
                      .subscribe(translations => {
                        text = translations['START_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    } else if(comapareData === 'endTime') {
                      let text;
                      this.translate.get(['END_CLASHES'])
                      .subscribe(translations => {
                        text = translations['END_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    }
                  }
                  });
                }
              }
             },(err) => {
               console.log(err);
             });
           } else {
                 this.loading = false;
                 this.authService.instance.setActiveAccount(this.authService.instance.getActiveAccount());
                 this.getAllAccountantOutlookEvent().then(value => {
                  let comapareData = this.checkInBetweenDates(rowData.bookingSlot.slotStartTime,rowData.bookingSlot.slotEndTime);
                  if(!comapareData) {
                    let outlookRequest = this.convertBookedSlotToOutlookEvent(rowData);
                    this.createSameEventOnOutlookCalendar(outlookRequest);
                      this.auth.approvedRejectAppoinment(this.usercaseIdAndStatus).subscribe(
                        (res: any) => {
                          let message;
                          let tempdata = res.data;
                          this.translate.get(['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'])
                            .subscribe(translations => {
                              message = translations['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'];
                            });
                          this.toastr.success(message, '',);
                          this.loading = false;
                          // this.openOutlookModel(tempdata);
                   
                          
                          if (this.isComponent == 'accountant-dashboard') {
                            this.broadCast.sendMessage("getListAfterDelete");
                            this.broadCast.sendMessage('accountant-dashboard');
                          }
                          if (this.isComponent == 'chief-Appoinment') {
                            this.broadCast.sendMessage("getDetailsAfterDelete");
                            this.broadCast.sendMessage('chief-account');
                          }
                        },
                        (err: any) => {
                          console.error("Something went wrong");
                        });
                  } else {
                    if(comapareData === 'inBetween') {
                      let text;
                      this.translate.get(['IN_TIME_CLASHES'])
                      .subscribe(translations => {
                        text = translations['IN_TIME_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    } else if(comapareData === 'startTime') {
                      let text;
                      this.translate.get(['START_CLASHES'])
                      .subscribe(translations => {
                        text = translations['START_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    } else if(comapareData === 'endTime') {
                      let text;
                      this.translate.get(['END_CLASHES'])
                      .subscribe(translations => {
                        text = translations['END_CLASHES'];
                      });
                      this.toastr.error(text, '');
                    }
                  }
                  });
         }
       } else {
        if(rowData) {
        this.createBookingSlotsForExchange(rowData); 
          this.auth.approvedRejectAppoinment(this.usercaseIdAndStatus).subscribe(
            (res: any) => {
              let message;
              let tempdata = res.data;
              this.translate.get(['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'])
                .subscribe(translations => {
                  message = translations['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.ACCEPT_APPOINTMENT'];
                });
              this.toastr.success(message, '',);
              this.loading = false;
              // this.openOutlookModel(tempdata);
       
              
              if (this.isComponent == 'accountant-dashboard') {
                this.broadCast.sendMessage("getListAfterDelete");
                this.broadCast.sendMessage('accountant-dashboard');
              }
              if (this.isComponent == 'chief-Appoinment') {
                this.broadCast.sendMessage("getDetailsAfterDelete");
                this.broadCast.sendMessage('chief-account');
              }
            },
            (err: any) => {
              console.error("Something went wrong");
            });

        }
       }
    } catch (error) {
      console.error("Error while fetching the data", error);
    }
  }

  checkInBetweenDates(start,end) {
    let st_date,en_date;
    let data1 = [];
    let data2 = [];
    let data3 = [];
    let data4 = [];
    let data5 = [];
    let startTime = new Date(start);
    let endTime = new Date(end);
    const particular_date = moment(startTime);
    const particular_date2 = moment(startTime);
    st_date = particular_date.startOf('day');
    en_date = particular_date2.endOf('day');
    let st_date_time = new Date(st_date);
    let en_date_time = new Date(en_date);
    if(this.outlookData) {
      data1 = this.outlookData.filter(x => (x.slotStartTime.getTime() >= startTime.getTime() && x.slotEndTime.getTime() <= endTime.getTime()));
      if(data1.length == 0) {
        data2 = this.outlookData.filter(x => (this.isDatesEqual(x.slotStartTime,startTime)));
        data3 = this.outlookData.filter(x => (this.isDatesEqual(x.slotEndTime,endTime)));
        data4 = this.outlookData.filter(x => ((x.slotStartTime.getTime() >= st_date_time.getTime() && x.slotEndTime.getTime() <= en_date_time.getTime()) &&  (x.slotStartTime.getTime() < startTime.getTime() && (x.slotEndTime.getTime() < endTime.getTime() && x.slotEndTime.getTime() > startTime.getTime()))));
        data5 = this.outlookData.filter(x => ((x.slotStartTime.getTime() >= st_date_time.getTime() && x.slotEndTime.getTime() <= en_date_time.getTime()) &&  (x.slotStartTime.getTime() > startTime.getTime() && (x.slotEndTime.getTime() > endTime.getTime() && x.slotStartTime.getTime() < endTime.getTime()))));
      }
      if(data1.length != 0) {
        return 'inBetween'
      } else if(data2.length != 0) {
        return 'startTime'
      } else if(data3.length != 0) {
        return 'endTime'
      } else if(data4.length != 0 ||  data5.length != 0) {
        return 'inBetween'
      }
       else {
        return null;
      }
    } else {
      return null;
    }
  }

  setUserCalendarAccounts(){
    if(this.currentUser?.userCalendarAccounts !== undefined){
      this.currentUser.userCalendarAccounts.forEach(userCalendarAccount => {
        if(userCalendarAccount.accountType == "MS_EXCHANGE"){
          this.userExchangeUserName = userCalendarAccount.accountEmail;
          this.userExchangePassword = userCalendarAccount.accountPassword;
        }
        if(userCalendarAccount.accountType == "MS_OUTLOOK"){
          this.userOutlookUsername = userCalendarAccount.accountEmail;
          this.userOutlookPassword = userCalendarAccount.accountPassword;
        }
      });
    }
  }

  createBookingSlotsForExchange(data){
    if(data){
      let exchangeLoginRequest = {
        "exchangeUsername" : this.userExchangeUserName,
        "exchangePassword" : this.userExchangePassword
      };
      this.apiCall.doExchangeLogin(exchangeLoginRequest).subscribe(
        (res: any) => {
          storageService.setItemAsJSON("exchangeUser", res);
          if(res.status == "SUCCESS"){
            let bookedSlot = data.bookingSlot;
            let subject = data.user.fullName
              let requestBody = {
                "exchangeUsername" : this.userExchangeUserName,
                "exchangePassword" : this.userExchangePassword,
                "appointmentStartDate" : bookedSlot.slotStartTime,
                "appointmentEndDate" : bookedSlot.slotEndTime,
                "appintmentURL" : bookedSlot.accountantBookingSlot.meetingLink,
                "appointmentSubject" : bookedSlot.accountantBookingSlot.subject,
                "appointmentBody" : bookedSlot.description,
              };
              this.apiCall.createExchangeAppointments(requestBody).subscribe((res) => {
                  console.log("Exchange =====", res)
              });
          }else {
            //this.showSpinner=false;
            // this.toastr.error("Wrong credentials, Please try again.", "");
          }
  
        },
        (err: any) => {
          //this.showSpinner=false;
          console.log("Something went wrong");
        }
      );
      
    }
  }

  openOutlookModel(tempdata) {
    try {
      let message;
      this.translate.get(['OUTLOOK_SYNC_EVENT'])
      .subscribe(translations => {
        message = translations['OUTLOOK_SYNC_EVENT'];
      }); 
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          event: true,
          title: "Logout",
          message: message,
          tempdata: tempdata
        },
      });
      return this.dialogRef.afterClosed();
    } catch (error) {
      console.error("Error while deactivating the component, ", error);
    }
  }

  convertBookedSlotToOutlookEvent(data) {
    try {
      let bookedSlot = data.bookingSlot;

      let subject = data.user.fullName
      let slotStartTime = bookedSlot.slotStartTime;
      let slotEndTime = bookedSlot.slotEndTime;
    
      let bookingSlot = {
        "subject": subject,
        "start": {
          "dateTime": slotStartTime,
          "timeZone": "UTC"
        },
        "end": {
          "dateTime": slotEndTime,
          "timeZone": "UTC"
        },
        "reminderMinutesBeforeStart": environment.REMINDER_MINUTES_BEFORE_START
      };

      return bookingSlot
    } catch (error) {
      console.error("Error while preparing outlook request body, ", error);
    }
  }

  createSameEventOnOutlookCalendar(data) {
    this.auth.createOutlookSlot(data).subscribe((res) => {
      console.log("convertVenaqiSlotToOutlookEvent: ", res);
    });
  }

  onRejectAppoinment(rowData) {
    try {
      this.usercaseIdAndStatus = {
        id: rowData.id,
        userCaseStatus: Status.Rejected,
        clientTimeZone: this.currentTimeZone
      }
      this.loading = true;
      this.auth.approvedRejectAppoinment(this.usercaseIdAndStatus).subscribe(
        (res: any) => {
          let message;
          this.translate.get(['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.CANCEL_APPOINTMENT'])
            .subscribe(translations => {
              message = translations['CHIEF_ACCOUNTANT.APPOINMENT_DETAILS.CANCEL_APPOINTMENT'];
            });
          this.toastr.success(message, '',);
          this.loading = false;
          if (this.isComponent == 'accountant-dashboard') {
            this.broadCast.sendMessage("getListAfterDelete");
            this.broadCast.sendMessage('accountant-dashboard');
          }
          if (this.isComponent == 'chief-Appoinment') {
            this.broadCast.sendMessage("getDetailsAfterDelete");
            this.broadCast.sendMessage('chief-account');
          }
        },
        (err: any) => {
          console.error("Something went wrong");
        });

    } catch (error) {
      console.error("Error while fetching the data", error);
    }
  }

  editDetails(data): void {
    if (data.active === false) {
      switch (this.isComponent) {
        case "superadmin_user":
          this.isEditEnabled = false;
          this.toastr.success('Please activate user first.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
        case "superadmin_organization":
          this.isEditEnabled = false;
          this.toastr.success('Requested organization is not active.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
        case "chief-account":
          this.isEditEnabled = false;
          this.toastr.success('Please activate user first.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          case "my-client":
            this.isEditEnabled = false
            this.toastr.success('Please activate user first.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
      }
      return;
    }
    switch (this.isComponent) {
      case "superadmin_user":
        this.dialog.open(EditUserComponent, {
          position: { right: "0" },
          height: "100%",
          data: data,
        });
        break;
      case "superadmin_organization":
        this.dialog.open(EditOrgnizationComponent, {
          position: { right: "0" },
          maxHeight: "100vh",
          data: data,
        });
        break;
      case "chief-account":
        this.dialog.open(EditChiefuserComponent, {
          position: { right: "0" },
          maxHeight: "100vh",
          data: data,
        });
        break;
        case "my-client":
        this.dialog.open(EditAccuserComponent, {
          position: { right: "0" },
          maxHeight: "100vh",
          data: data,
        });
        break;
          case "ca-my-client": 
          this.dialog.open(EditChiefuserComponent, {
            position: { right: "0" },
            maxHeight: "100vh",
            data: data,
          });
          break;
    }
  }

  activeInactive($event: any, data: any) {
    try {
      let active_org
      let would_text
      let activate_text;
      this.translate.get(['ACTIVATE_ORGANISATION'])
      .subscribe(translations => {
        active_org = translations['ACTIVATE_ORGANISATION'];
      });
      this.translate.get(['WOULD_BE_TEXT'])
      .subscribe(translations => {
        would_text = translations['WOULD_BE_TEXT'];
      });
      let activatedMsg = data.active ? "Inactivated" : "Activated";
      if(activatedMsg === 'Activated') {
        this.translate.get(['ACTIVATE_TXT'])
        .subscribe(translations => {
          activate_text = translations['ACTIVATE_TXT'];
        });
      } else {
        this.translate.get(['INACTIVATE_TXT'])
        .subscribe(translations => {
          activate_text = translations['INACTIVATE_TXT'];
        });
      }
      switch (this.isComponent) {
        case 'superadmin_organization':
          $event.preventDefault();

          // Get confirmation for activate/inactivate organization
          let decisionRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: {
              title: "Active/Inactive Confirm",
              message: active_org + ' ' + `${data.organizationName} ` + would_text + ' ' + activate_text + ' ' + '!',
            },
          });

          decisionRef.afterClosed().subscribe((result) => {

            // Here result = true means user want's activate/inactivate organization 
            if (result) {
              this.auth.activeInactiveOrganization(data.id, !data.active).subscribe((res) => {
                data.active = res.data.active;
                if(res.message === 'The organization activated successfully.') {
                  this.translate.get(['ORGANIZATION_ACTIVE_APPOINTMENT'])
                  .subscribe(translations => {
                    this.toastr.success(translations['ORGANIZATION_ACTIVE_APPOINTMENT'], '', {
                      timeOut: 3000, messageClass: 'test'
                    }); 
                  });
                } else {
                  this.translate.get(['ORGANIZATION_INACTIVE_APPOINTMENT'])
                  .subscribe(translations => {
                    this.toastr.success(translations['ORGANIZATION_INACTIVE_APPOINTMENT'], '', {
                      timeOut: 3000, messageClass: 'test'
                    }); 
                  });
                }
              }, (error) => {
                console.error("Error occurred while activate/inactivate organization : ", error);
              });
            } else {
              console.warn("Don't activate/inactivate organization");
            }
          });
          break;
        case 'superadmin_user':
          $event.preventDefault();
          this.auth.updateSuperAdminUser({ ...data, active: !data.active }).subscribe((res) => {
            if (res.status === "SUCCESS") {
              data.active = !data.active;
              if(data.active) {
                this.translate.get(['SUPER_ADMIN_USER_ACTIVATE'])
                .subscribe(translation=>{
                  this.message=translation['SUPER_ADMIN_USER_ACTIVATE']
                });
                this.toastr.success(this.message, "", { timeOut: 3000 });

              } else {
                this.translate.get(['SUPER_ADMIN_USER_DEACTIVATE']).subscribe(translation=>{
                  this.message = translation['SUPER_ADMIN_USER_DEACTIVATE']
                });
                this.toastr.success(this.message, "", { timeOut: 3000 });
              }
                } 
             else {
              this.translate.get(['SUPER_ADMIN_ERROR_ACTIVATE']).subscribe(translation=>{
                this.message = translation['SUPER_ADMIN_ERROR_ACTIVATE']
              });
              this.toastr.error(this.message, "", { timeOut: 3000 });
            }
          }, (error) => {
            console.error("Error : ", error);
          });
          break;
      }
    } catch (error) {
      console.error("Error occurred : ", error);
    }
  }


  isPreviousDate(rowData) {
    try {
      if(rowData.bookingSlot) {
        let slotStartTime: Date = rowData.bookingSlot ? new Date(rowData.bookingSlot.slotStartTime) : null;
        let currentTime: Date = new Date();
        return !(currentTime.getTime() > slotStartTime.getTime());
      }
    } catch (error) {
      console.warn("Error to getting time slots", error);
    }
  }

  isPassedDate(rowData) {
    try {
      if(rowData.bookingSlot) {
        let slotStartTime: Date = rowData.bookingSlot ? new Date(rowData.bookingSlot.slotStartTime) : null;
        let currentTime: Date = new Date();
        return (currentTime.getTime() > slotStartTime.getTime());
      }
    } catch (error) {
      console.warn("Error to getting time slots", error);
    }
  }


  deleteDetails(data): void {
    this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETE_CONFIRM_MESSAGE'])
      .subscribe(translations => {
        this.deleteMessage = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETE_CONFIRM_MESSAGE'];
      });
    if (data.active === false) {
      switch (this.isComponent) {
        case 'superadmin_user':
          this.isDeleteEnabled = false;
          this.toastr.success('Please activate user first.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
        case 'superadmin_organization':
          this.isDeleteEnabled = false;
          this.toastr.success('Requested organization is not active.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
        case "chief-account":
          this.isEditEnabled = false;
          this.toastr.success('Please activate user first.', '', {
            timeOut: 3000, messageClass: 'test'
          });
          break;
      }
      return;
    }
    switch (this.isComponent) {
      case "ca-feedback":
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: this.deleteMessage,
          },
        });
        this.dialogRef.afterClosed().subscribe((decision) => {
          if (decision) {
            this.auth.deleteFeedback(data.user.id, data.feedbackId,).subscribe(
              (response: any) => {
                this.loading = true;
                if (response.status == "SUCCESS") {
                  this.createToaster = response.message;
                
                  this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                    .subscribe(translations => {
                      this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                    });
                  this.toastr.success(this.createToaster, '');
                  this.loading = false;

                } else {
                  this.toastr.error(response.message, '');
                  this.loading = false;
                }
              },
              (error) => {
                console.log("Something went wrong ", error);
              }
            );
            this.broadCast.sendMessage("getAllFeedbacks");
          }
        })
        break;

        case "ca-employee-returns":
          this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: {
              title: "Delete Confirm",
              message: this.deleteMessage,
            },
          });
          this.dialogRef.afterClosed().subscribe((decision) => {
            if (decision) {
              this.auth.deleteAccFeedback(data.user.id, data.feedbackId,).subscribe(
                (response: any) => {
                  this.loading = true;
                  if (response.status == "SUCCESS") {
                    this.createToaster = response.message;
                    this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                      .subscribe(translations => {
                        this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                      });
                    this.toastr.success(this.createToaster, '');
                    this.loading = false;
                  } else {
                    this.toastr.error(response.message, '');
                    this.loading = false;
                  }
                },
                (error) => {
                  console.log("Something went wrong ", error);
                }
              );
              this.broadCast.sendMessage("getAllFeedbacks");
            }
          });
          break;

          case "acc-employee-returns":
            this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
              maxWidth: "400px",
              data: {
                title: "Delete Confirm",
                message: this.deleteMessage,
              },
            });
            this.dialogRef.afterClosed().subscribe((decision) => {
              if (decision) {
                this.auth.deleteAccFeedback(data.user.id, data.feedbackId,).subscribe(
                  (response: any) => {
                    this.loading = true;
                    if (response.status == "SUCCESS") {
                      this.createToaster = response.message;
                      this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                        .subscribe(translations => {
                          this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                        });
                      this.toastr.success(this.createToaster, '');
                      this.loading = false;
                    } else {
                      this.toastr.error(response.message, '');
                      this.loading = false;
                    }
                  },
                  (error) => {
                    console.log("Something went wrong ", error);
                  }
                );
                this.broadCast.sendMessage("getAllFeedbacks");
              }
            });
            break;
  
            case "acc-my-accounting-firm":
              this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                maxWidth: "400px",
                data: {
                  title: "Delete Confirm",
                  message: this.deleteMessage,
                },
              });
              this.dialogRef.afterClosed().subscribe((decision) => {
                if (decision) {
                  this.auth.deleteFeedback(data.user.id, data.feedbackId).subscribe(
                    (response: any) => {
                      this.loading = true;
                      if (response.status == "SUCCESS") {
                        this.createToaster = response.message;
                        this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                          .subscribe(translations => {
                            this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                          });
                        this.toastr.success(this.createToaster, '');
                        this.loading = false;
                      } else {
                        this.toastr.error(response.message, '');
                        this.loading = false;
                      }
                    },
                    (error) => {
                      console.log("Something went wrong ", error);
                    }
                  );
                  this.broadCast.sendMessage("getAllFeedbacks");
                }
              });
              break;

              case "ca-employee-satisfaction":
                this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                  maxWidth: "400px",
                  data: {
                    title: "Delete Confirm",
                    message: this.deleteMessage,
                  },
                });
                this.dialogRef.afterClosed().subscribe((decision) => {
                  if (decision) {
                    this.auth.deleteFeedback(data.user.id, data.feedbackId).subscribe(
                      (response: any) => {
                        this.loading = true;
                        if (response.status == "SUCCESS") {
                          this.createToaster = response.message;
                          this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                            .subscribe(translations => {
                              this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                            });
                          this.toastr.success(this.createToaster, '');
                          this.loading = false;
                        } else {
                          this.toastr.error(response.message, '');
                          this.loading = false;
                        }
                      },
                      (error) => {
                        console.log("Something went wrong ", error);
                      }
                    );
                    this.broadCast.sendMessage("getAllFeedbacks");
                  }
                });
                break;
                case "ca-accountant-performance-feedback":
                  this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    maxWidth: "400px",
                    data: {
                      title: "Delete Confirm",
                      message: this.deleteMessage,
                    },
                  });
                  this.dialogRef.afterClosed().subscribe((decision) => {
                    if (decision) {
                      this.auth.deleteLinkedFeedback(data.userFeedbackDetails[0].id).subscribe(
                        (response: any) => {
                          this.loading = true;
                          if (response.status == "SUCCESS") {
                            this.createToaster = response.message;
                            this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                              .subscribe(translations => {
                                this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                              });
                            this.toastr.success(this.createToaster, '');
                            this.broadCast.sendMessage("getAllLinkFeedback");
                            this.loading = false;
                          } else {
                            this.toastr.error(response.message, '');
                            this.loading = false;
                          }
                        },
                        (error) => {
                          console.log("Something went wrong ", error);
                        }
                      );
                 
                    }
                  });
                  break;
                case "ca-indentify-customer-needs":
                    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                      maxWidth: "400px",
                      data: {
                        title: "Delete Confirm",
                        message: this.deleteMessage,
                      },
                    });
                    this.dialogRef.afterClosed().subscribe((decision) => {
                      if (decision) {
                        this.auth.deleteFeedback(data.user.id, data.feedbackId,).subscribe(
                          (response: any) => {
                            this.loading = true;
                            if (response.status == "SUCCESS") {
                              this.createToaster = response.message;
                            
                              this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                                .subscribe(translations => {
                                  this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                                });
                              this.toastr.success(this.createToaster, '');
                              this.loading = false;
            
                            } else {
                              this.toastr.error(response.message, '');
                              this.loading = false;
                            }
                          },
                          (error) => {
                            console.log("Something went wrong ", error);
                          }
                        );
                        this.broadCast.sendMessage("getAllFeedbacks");
                      }
                    })
                    break;
                    case "ca-periodic-evaluation":
                    case "acc-my-professional-journey" :
                    case "ca-annual-evaluation" :
                    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                      maxWidth: "400px",
                      data: {
                        title: "Delete Confirm",
                        message: this.deleteMessage,
                      },
                    });
                    this.dialogRef.afterClosed().subscribe((decision) => {
                      if (decision) {
                        if(this.isComponent === "ca-annual-evaluation"){
                          this.type = 2
                        }
                        this.auth.deleteEvaluationFeedback(data.user.id, data.id,this.type).subscribe(
                          (response: any) => {
                            this.loading = true;
                            if (response.status == "SUCCESS") {
                              this.createToaster = response.message;
                            
                              this.translate.get(['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'])
                                .subscribe(translations => {
                                  this.createToaster = translations['CHIEF_ACCOUNTANT.FEEDBACK.DETAILS.DELETED_TOASTER_MESSAGE'];
                                });
                              this.toastr.success(this.createToaster, '');
                              this.loading = false;
            
                            } else {
                              this.toastr.error(response.message, '');
                              this.loading = false;
                            }
                          },
                          (error) => {
                            console.log("Something went wrong ", error);
                          }
                        );
                        this.broadCast.sendMessage("getAllFeedbacks");
                      }
                    })
                    break;
    
      case "superadmin_user":
        let message3 = [];
        this.translate.get(['DELETE_USER_MESSAGE_CONFIRM'])
        .subscribe(translations => {
          message3 = translations['DELETE_USER_MESSAGE_CONFIRM'];
        });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: message3 + ' ' + `${data?.firstName} ?`,
          },
        });

        // listen to response
        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.auth.deleteSuperAdminUser(data.id).subscribe((res: any) => {
              this.loading = true;
              try {
                if (res.status == "SUCCESS") {
                  this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'])
                    .subscribe(translations => {
                      this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'];
                    });
                  this.toastr.success(this.deleteUserToaster, '');
                  this.loading = false;
                } else {
                  this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'])
                    .subscribe(translations => {
                      this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'];
                    });
                  this.toastr.error(this.deleteUserToaster, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage("getUser");
                this.broadCast.sendMessage("organization");
              } catch {
                this.toastr.success("Error occured while user delete.", "");
              }
            });
          }
        });
        break;

      case "superadmin_organization":
        this.translate.get(['P_TABlE.SA_ORG_MSG'])
          .subscribe(translations => {
            this.message = translations['P_TABlE.SA_ORG_MSG'];
          });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: this.message + ` ${data.organizationName} ?`,
          },
        });

        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.auth.softDeleteOrganization(data.id).subscribe((res: any) => {
              this.loading = true;
              this.deleteSuccess = res.message;
              this.translate.get(['P_TABlE.DELETE_ORG'])
                .subscribe(translations => {
                  this.deleteSuccess = translations['P_TABlE.DELETE_ORG'];
                });
              try {
                if (res.status == "SUCCESS") {
                  this.toastr.success(this.deleteSuccess, '');
                  this.loading = false;
                } else {
                  this.toastr.error(res.message, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage('displayData');
                this.broadCast.sendMessage('organization');
              } catch {
                this.toastr.success('Error occured while organization delete.', '', {
                  timeOut: 3000
                });
              }
            })
          }
        });
        break;

      case "chief-account": 
      let message12 = [];
      this.translate.get(['DELETE_USER_MESSAGE_CONFIRM'])
      .subscribe(translations => {
        message12 = translations['DELETE_USER_MESSAGE_CONFIRM'];
      });
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Delete Confirm",
          message: message12 + ' ' + `${data?.firstName} ?`,
        },
      });
        // listen to response
        try {
          this.dialogRef.afterClosed().subscribe((res) => {
            if (res) {
              this.auth.deleteSuperAdminUser(data.id).subscribe((res: any) => {
                this.loading = true;
                if (res.status == "SUCCESS") {
                  this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'])
                    .subscribe(translations => {
                      this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'];
                    });
                  this.toastr.success(this.deleteUserToaster, '');
                  this.loading = false;
                } else {
                  this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'])
                    .subscribe(translations => {
                      this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'];
                    });
                  this.toastr.error(this.deleteUserToaster, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage('getChiefAccUsers');
                this.broadCast.sendMessage('chief-account');
              },
                (err) => {
                  console.error("Backend error ", err);
                },
                () => {
                });
            }
          });
        } catch {
          this.toastr.success("Error occured while user delete.", "");
        }
        break;
        case "chief-account": 
        let message13 = [];
        this.translate.get(['DELETE_USER_MESSAGE_CONFIRM'])
        .subscribe(translations => {
          message13 = translations['DELETE_USER_MESSAGE_CONFIRM'];
        });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: message13 + ' ' + `${data?.firstName} ?`,
          },
        });
          // listen to response
          try {
            this.dialogRef.afterClosed().subscribe((res) => {
              if (res) {
                this.auth.deleteSuperAdminUser(data.id).subscribe((res: any) => {
                  this.loading = true;
                  if (res.status == "SUCCESS") {
                    this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'])
                      .subscribe(translations => {
                        this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_SUCCESS'];
                      });
                    this.toastr.success(this.deleteUserToaster, '');
                    this.loading = false;
                  } else {
                    this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'])
                      .subscribe(translations => {
                        this.deleteUserToaster = translations['SUPER_ADMIN.USERS.ADD_USER.DELETE_ERROR'];
                      });
                    this.toastr.error(this.deleteUserToaster, '');
                    this.loading = false;
                  }
                  this.broadCast.sendMessage('getChiefAccUsers');
                  this.broadCast.sendMessage('chief-account');
                },
                  (err) => {
                    console.error("Backend error ", err);
                  },
                  () => {
                  });
              }
            });
          } catch {
            this.toastr.success("Error occured while user delete.", "");
          }
          break;
  
      case "client-appoinment":
        let message;
        this.translate.get(['APPOINTMENT_DIALOG_DELETE'])
          .subscribe(translations => {
            message = translations['APPOINTMENT_DIALOG_DELETE'];
          });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: message + ` ${data.accountant?.firstName} ?`,
          },
        });
        // listen to response
        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.auth.deleteAccountantOnClientPage(data.id).subscribe((res: any) => {
              this.loading = true;
              try {
                if (res.status == "SUCCESS") {
                  let message;
                  if (res.message === 'Appointment deleted successfully.') {
                    this.translate.get(['APPOINTMENT_DELETED'])
                      .subscribe(translations => {
                        message = translations['APPOINTMENT_DELETED'];
                      });
                  }
                  this.toastr.success(message, '');
                  this.loading = false;
                } else {
                  this.toastr.error(res.message, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage("getAccountantList");
                this.broadCast.sendMessage('client-profile');
              } catch {
                this.toastr.success("Error occured while user delete.", "");
              }
            });
          }
        });
        break;

      case "accountant-dashboard":
        let message1;
        this.translate.get(['APPOINTMENT_DIALOG_DELETE'])
          .subscribe(translations => {
            message1 = translations['APPOINTMENT_DIALOG_DELETE'];
          });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: message1 + ` ${data.accountant?.firstName} ?`,
          },
        });
        // listen to response
        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.auth.deleteAccountantOnClientPage(data.id).subscribe((res: any) => {
              this.loading = true;
              try {
                if (res.status == "SUCCESS") {
                  let message;
                  if (res.message === 'Appointment deleted successfully.') {
                    this.translate.get(['APPOINTMENT_DELETED'])
                      .subscribe(translations => {
                        message = translations['APPOINTMENT_DELETED'];
                      });
                  }
                  this.toastr.success(message, '');
                  this.loading = false;
                } else {
                  this.toastr.error(res.message, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage("getListAfterDelete");
                this.broadCast.sendMessage('accountant-dashboard');
              } catch {
                this.toastr.success("Error occured while user delete.", "");
              }
            });
          }
        });
        break;

      case "chief-Appoinment":
        let message2;
        this.translate.get(['APPOINTMENT_DIALOG_DELETE'])
          .subscribe(translations => {
            message2 = translations['APPOINTMENT_DIALOG_DELETE'];
          });
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Delete Confirm",
            message: message2 + ` ${data.accountant?.firstName} ?`,
          },
        });
        // listen to response
        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.auth.deleteAccountantOnClientPage(data.id).subscribe((res: any) => {
              this.loading = true;
              try {
                if (res.status == "SUCCESS") {
                  let message;
                  if (res.message === 'Appointment deleted successfully.') {
                    this.translate.get(['APPOINTMENT_DELETED'])
                      .subscribe(translations => {
                        message = translations['APPOINTMENT_DELETED'];
                      });
                  }
                  this.toastr.success(message, '');
                  this.loading = false;
                } else {
                  this.toastr.error(res.message, '');
                  this.loading = false;
                }
                this.broadCast.sendMessage("getDetailsAfterDelete");
                this.broadCast.sendMessage('chief-account');
              } catch {
                this.toastr.success("Error occured while user delete.", "");
              }
            });
          }
        });
        break;

    }
  }

  changed($event: MatSlideToggleChange, data: any): void {
    switch (this.isComponent) {

      case "chief-account":
        try {
          data.active = $event.checked;
          this.auth.updateSuperAdminUser(data).subscribe((res) => {
            if ($event.checked == true) {
              this.translate.get(['CHIEF_ACCOUNTANT.USERS.ADD_USER.ACTIVATE_SUCCESS'])
              .subscribe(translation=>{
                this.message=translation['CHIEF_ACCOUNTANT.USERS.ADD_USER.ACTIVATE_SUCCESS']
              })
              this.toastr.success(this.message,"", { timeOut: 3000 });

                }  else {
                  this.translate.get(['CHIEF_ACCOUNTANT.USERS.ADD_USER.DEACTIVATE_SUCCESS']).subscribe(translation=>{
                    this.message=translation['CHIEF_ACCOUNTANT.USERS.ADD_USER.DEACTIVATE_SUCCESS']
                  })
                  this.toastr.success(this.message, "", { timeOut: 3000 });
                }
          },
            (err) => {
              console.error("Backend error ", err);
            },
            () => {
            }
          );
        } catch {
          this.toastr.success("Error occured while updating user.", "", {
            timeOut: 3000,
          });
        }
        break;
    }
  }

  enableFilter() {
    this.clearFilterEnable.emit({flag : true});
  }

  changedAppointmentStatus($event: MatSlideToggleChange, data: any): void {
    switch (this.isComponent) {
    
    case "superadmin_organization":
    try {
    let tempData = {
    id: data.id,
    organizationName: data.organizationName,
    organizationEmail: data.organizationEmail,
    contactNumber: data.contactNumber,
    emailNotification: data.emailNotification,
    fixedLimit: data.fixedLimit,
    organizationAddress : data.organizationAddress,
    empSatisfactionActive : data.empSatisfactionActive,
    customerFeedbackActive : data.customerFeedbackActive,
    appointmentActive : $event.checked,
    }
    this.auth.updateOrganizationAppointmentStatus(tempData).subscribe((res: any) => {
    if (res.status == "SUCCESS") {
    if ($event.checked == true) {
      this.translate.get(['MAKE_APPOINTMENT_ACTIVE_TEXT'])
      .subscribe(translations => {
        this.toastr.success(translations['MAKE_APPOINTMENT_ACTIVE_TEXT'], "", {
          timeOut: 3000,
          });
          this.loadOrganizations(0, 10, name);
      });
    } else {
      this.translate.get(['MAKE_APPOINTMENT_INACTIVE_TEXT'])
      .subscribe(translations => {
        this.toastr.success(translations['MAKE_APPOINTMENT_INACTIVE_TEXT'], "", {
          timeOut: 3000,
          });
          this.loadOrganizations(0, 10, name);
      });
    }
    }
    },
    (err) => {
    console.error("Backend error ", err);
    },
    () => {
    }
    );
    } catch {
    this.toastr.success("Error occured while updating user.", "", {
    timeOut: 3000,
    });
    }
    break;
    }
    }

    changedEmployeeSatisfactionStatus($event: MatSlideToggleChange, data: any): void {
      switch (this.isComponent) {
      
      case "superadmin_organization":
      try {
      let tempData = {
      id: data.id,
      organizationName: data.organizationName,
      organizationEmail: data.organizationEmail,
      contactNumber: data.contactNumber,
      emailNotification: data.emailNotification,
      fixedLimit: data.fixedLimit,
      organizationAddress : data.organizationAddress,
      appointmentActive : data.appointmentActive,
      empSatisfactionActive : $event.checked,
      customerFeedbackActive : data.customerFeedbackActive
      }
      this.auth.updateOrganizationAppointmentStatus(tempData).subscribe((res: any) => {
      if (res.status == "SUCCESS") {
      if ($event.checked == true) {
        this.translate.get(['EMPLOYEE_SATISFACTION_TRACKING_ACTIVE'])
        .subscribe(translations => {
          this.toastr.success(translations['EMPLOYEE_SATISFACTION_TRACKING_ACTIVE'], "", {
            timeOut: 3000,
            });
            this.loadOrganizations(0, 10, name);
        });
      } else {
        this.translate.get(['EMPLOYEE_SATISFACTION_TRACKING_INACTIVE'])
        .subscribe(translations => {
          this.toastr.success(translations['EMPLOYEE_SATISFACTION_TRACKING_INACTIVE'], "", {
            timeOut: 3000,
            });
            this.loadOrganizations(0, 10, name);
        });
      }
      }
      },
      (err) => {
      console.error("Backend error ", err);
      },
      () => {
      }
      );
      } catch {
      this.toastr.success("Error occured while updating user.", "", {
      timeOut: 3000,
      });
      }
      break;
      }
      }

      customerFeedbackStatus($event: MatSlideToggleChange, data: any): void {
        switch (this.isComponent) {
        
        case "superadmin_organization":
        try {
        let tempData = {
        id: data.id,
        organizationName: data.organizationName,
        organizationEmail: data.organizationEmail,
        contactNumber: data.contactNumber,
        emailNotification: data.emailNotification,
        fixedLimit: data.fixedLimit,
        organizationAddress : data.organizationAddress,
        appointmentActive : data.appointmentActive,
        empSatisfactionActive : data.empSatisfactionActive,
        customerFeedbackActive : $event.checked
        }
        this.auth.updateOrganizationAppointmentStatus(tempData).subscribe((res: any) => {
        if (res.status == "SUCCESS") {
        if ($event.checked == true) {
          this.translate.get(['CUSTOMER_FEEDBACK_ACTIVATE_SUCCESS'])
          .subscribe(translations => {
            this.toastr.success(translations['CUSTOMER_FEEDBACK_ACTIVATE_SUCCESS'], "", {
              timeOut: 3000,
              });
              this.loadOrganizations(0, 10, name);
          });
        } else {
          this.translate.get(['CUSTOMER_FEEDBACK_DEACTIVATE_SUCCESS'])
          .subscribe(translations => {
            this.toastr.success(translations['CUSTOMER_FEEDBACK_DEACTIVATE_SUCCESS'], "", {
              timeOut: 3000,
              });
              this.loadOrganizations(0, 10, name);
          });
        }
        }
        },
        (err) => {
        console.error("Backend error ", err);
        },
        () => {
        }
        );
        } catch {
        this.toastr.success("Error occured while updating user.", "", {
        timeOut: 3000,
        });
        }
        break;
        }
        }
  // Server side pagination
  loadData($event) {
    try {

        // let first = $event.first;
        // let rows = $event.rows;
        let pageNo = 0;
        let pageSize = 10;
      let userId = this.currentUser?.id;
      let organizationId = this.currentUser?.organizationId;
      let name = $event?.filters?.name?.value ? $event.filters.name.value : "";
      if(name != '') {
        this.clearFilterEnable.emit({flag : true});
      }
      switch (this.isComponent) {
        case ComponentType.SUPER_ADMIN_ORGANIZATION: {
          this.loadOrganizations(pageNo, pageSize, name);
          break;
        }
        case ComponentType.SUPER_ADMIN_USER: {
          this.loadUsers(pageNo, pageSize, this.filterBy, name);
          break;
        }
        case ComponentType.CHIEF_ACCOUNTANT_USER: {
          this.loadUsers(pageNo, pageSize, this.filterBy, name);
          break;
        }
        case ComponentType.CLIENT_APPOINTMENTS: {
          this.loadMyAppointment(pageNo, pageSize, userId,name);
          break;
        }
        case ComponentType.ACCOUNTANT_APPOINTMENTS: {
          this.loadMyAppointment(pageNo, pageSize, userId,name);
          break;
        }
        case ComponentType.CHIEF_ACCOUNTANT_APPOINTMENTS: {
          this.loadMyAppointment(pageNo, pageSize, userId,name);
          break;
        }
        case ComponentType.CHIEF_ACCOUNTANT_FEEDBACK: {
          this.loadFeedback(0,pageNo, pageSize, organizationId, userId,false,false);
          break;
        }
        case ComponentType.EMPLOYEE_RETURNS : {
          this.loadFeedback(0,pageNo, pageSize, organizationId, userId,true,false);
          break;
        }
        case ComponentType.ACC_EMPLOYEE_RETURNS : {
          this.loadFeedback(1,pageNo, pageSize, organizationId, userId,true,false);
          break;
        }
        case ComponentType.ACC_MY_ACCOUNTING_FIRM : {
          this.loadSpecialityFeedback(pageNo, pageSize, organizationId, true);
          break;
        }
        case ComponentType.CA_EMPLOYEE_SATISFACTION : {
          this.loadSpecialityFeedback(pageNo, pageSize, organizationId, false);
          break;
        }
        case ComponentType.CA_CUST_IDENTIFICATION_NEED : {
          this.loadFeedback(0,pageNo, pageSize, organizationId, userId,false,true);
          break;
        }
        case ComponentType.ACC_CUST_IDENTIFICATION_NEED : {
          this.loadIdentCustNeedData(0,pageNo, pageSize, organizationId, userId,false,true);
          break;
        }
        case ComponentType.CA_PERIODIC_EVALUTION : {
          this.loadEvaluationFeedbackData(1 , false);
          break;
        }
        case ComponentType.CA_ANNUAL_EVALUATION : {
          this.loadEvaluationFeedbackData(2 , false);
          break;
        }
        case ComponentType.ACC_ANNUAL_INTERVIEW : {
          this.loadEvaluationFeedbackData(2 , true)
          break;
        }
        case ComponentType.ACC_MY_PROFESSIONAL_JOURNEY : {
          this.loadEvaluationFeedbackData(1, true);
          break;
        }
        case ComponentType.CA_ACCOUNTANT_PERFORMANCE_FEEDBACK : {
          this.loadLinkedAccFeedback();
          break;
        }
        default:
          break;
      }
    }
    catch (error) {
      console.error("Error while loading data, ", error);
    }
  }

  loadOrganizations(pageNo, pageSize, organizationName) {
    try {
      this.loading = true;
      this.auth.getOrganizationByPage(pageNo, pageSize, organizationName).subscribe(
        (res: any) => {
          if (res.status === "SUCCESS") {
            if(res.data != null) {

              this.data = res.data.data;
              this.totalRecords = res.data.totalRecords;
            }
          }
        },
        (error) => {
          console.error("API error, ", error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      console.error("Error while loading organizations, ", error);
    }
  }

  loadUsers(pageNo, pageSize, filterBy, userName) {
    try {
      this.loading = true;
      this.auth.getUserByPage(pageNo, pageSize, filterBy, userName).subscribe(
        (res: any) => {
          if(res.data != null) {

            this.data = res.data.data;
            this.totalRecords = res.data.totalRecords;
          }
        },
        (error) => {
          console.error("API error, ", error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      console.error("Error while loading users, ", error);
    }
  }

  loadMyAppointment(pageNo, pageSize, userId,name) {
    try {
      this.loading = true;
      this.auth.getMyAppointmentByPage(pageNo, pageSize, userId, this.filterBy, this.filterValue,name).subscribe(
        (res: any) => {
          if(res.data != null) {
            this.data = res.data.data;
            this.totalRecords = res.data.totalRecords;
          }
          // this.data = [...this.data];
        },
        (error) => {
          console.error("API error, ", error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      console.error("Error while loading MyAppointmentByPage, ", error);
    }
  }
  loadLinkedAccFeedback() {
    const checkData = () => {
        if (this.totalAverageRatings !== undefined && this.data !== undefined) {
          this.totalAverageRating = this.totalAverageRatings
         this.cloneTableData = this.data;
         this.accName = this.data[0]?.accName ? this.data[0].accName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : '';
         this.loadExportData.emit({'data' : this.data});
            
        } else {
            setTimeout(checkData, 200);
        }
    };
    checkData();
}



  loadFeedback(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,isAcc , isCustIdentify) {
    try {
      this.loading = true;
      if(!isAcc) {
        this.auth.getFeedbackByPage(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,false,false, isCustIdentify, false).subscribe(
          (res: any) => {
            if(res.data != null) {
              this.data = res.data.data;
              this.cloneTableData = this.data;
              this.totalRecords = res.data.totalRecords;
              this.totalAverageRating= res.data.totalAverageRating;
              this.loadFeed.emit({'data' : this.data});
              this.loadAverageRatings.emit({'ratingData': this.totalAverageRating});
            }
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
        this.auth.getFeedbackByPage(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,true,false,isCustIdentify, false).subscribe(
          (res: any) => {
            if(res.data != null) {

              this.exportData = res.data.data;
              this.loadExportData.emit({'data' : this.exportData});
            }
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      } else {
        this.auth.getFeedbackByPage(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,false,true,false, true).subscribe(
          (res: any) => {
            this.data = res.data?.data;
            this.cloneTableData = this.data;
            this.totalRecords = res.data?.totalRecords;
            this.totalAverageRating= res.data?.totalAverageRating;
            this.loadFeed.emit({'data' : res.data?.data});
            this.loadAverageRatingsAcc.emit({'ratingData': this.totalAverageRating});
            this.exportData = res.data.data;
            this.loadExportData.emit({'data' : this.exportData});
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      }
    
    } catch (error) {
      console.error("Error while loading MyAppointmentByPage, ", error);
    }
  }

  loadIdentCustNeedData(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,isAcc , isCustIdentify) {
    try {
      this.loading = true;
      if(!isAcc) {
        this.auth.getFeedbackByPage(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,false,false, isCustIdentify, false).subscribe(
          (res: any) => {
            if(res.data != null) {
              this.data = res.data.data;
              this.cloneTableData = this.data;
              this.allClientData  = this.data
              // this.loadFeed.emit({'data' : this.data});
              // this.loadAverageRatings.emit({'ratingData': this.totalAverageRating});
            }
          
              this.getMyClientList();
          
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
        this.auth.getFeedbackByPage(accReturns,pageNo, pageSize, organizationId, chiefAccountantId,true,false,isCustIdentify, false).subscribe(
          (res: any) => {
            if(res.data != null) {

              this.exportData = res.data.data;
              this.loadExportData.emit({'data' : this.exportData});
            }
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      } 

    
    } catch (error) {
      console.error("Error while loading MyAppointmentByPage, ", error);
    }
  }

  loadEvaluationFeedbackData(type , isAccountant) {
    try {
      this.loading = true;
      if(!isAccountant){
        this.auth.getPeriodicFeedback(type , false).subscribe(
          (res: any) => {
            if(res.data != null) {
              this.data = res.data;
              this.cloneTableData = this.data;
              this.exportData = res.data;
              this.loadExportData.emit({'data' : this.exportData});
            }          
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );

      }else{
        this.auth.getPeriodicFeedback(type , true).subscribe(
          (res: any) => {
            if(res.data != null) {
              this.data = res.data;
              this.cloneTableData = this.data;
              this.exportData = res.data;
              this.loadExportData.emit({'data' : this.exportData});
            }          
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      }
    } catch (error) {
      console.error("Error while loading MyAppointmentByPage, ", error);
    }
  }


  getMyClientList() {
    try {
      this.showSpinner = true;
      this.visible = false;
      this.myClientFeedbackData = [];

      this.auth.getMyClient().subscribe((res: any) => {
        if (res.status === 'SUCCESS') {
          this.showSpinner = false;
          
          if (res.data != null) {
            const tempData = res.data;

            tempData.forEach((x) => {
              this.data.forEach((y) => {
                if (x.id === y.user.id) {
                  this.myClientFeedbackData.push(y);
                }
              });
            });
            this.data = [...this.myClientFeedbackData];
            this.myClientData = this.myClientFeedbackData
            this.cloneTableData = this.data
            this.visible = true;
            this.showSpinner = false;
            this.calcAvgRatingFilter(this.data)
              this.loadFeed.emit({'data' : this.data});
              this.loadAverageRatings.emit({'ratingData': this.totalAverageRating});

          }
        }
      });
    } catch (error) {
      console.error(error);
    }
}

  loadSpecialityFeedback(pageNo, pageSize, organizationId,isAcc) {
    try {
      this.loading = true;
      if(isAcc) {
        this.auth.getSpecialityFeedbackByPage(pageNo, pageSize, organizationId, false,true).subscribe(
          (res: any) => {
            if(res.data != null) {
              this.data = res.data.data;
              this.totalRecords = res.data.totalRecords;
              this.totalAverageRating= res.data.totalAverageRating;
              this.calcAvgRatingFilter(this.data)
              this.loadFeed.emit({'data' : this.data});
              this.loadAverageRatings.emit({'ratingData': this.totalAverageRating});
              this.exportData = res.data.data;
              this.loadExportData.emit({'data' : this.exportData});
            }
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      } else {
        this.auth.getSpecialityFeedbackByPage(pageNo, pageSize, organizationId, false,false).subscribe(
          (res: any) => {
            if(res.data != null) {
            this.data = res.data?.data;
            this.cloneTableData = this.data;
            this.totalRecords = res.data?.totalRecords;
            this.totalAverageRating= res.data?.totalAverageRating;
            this.loadFeed.emit({'data' : res.data?.data});
            this.loadAverageRatingsAcc.emit({'ratingData': this.totalAverageRating});
            this.exportData = res.data.data;
            this.loadExportData.emit({'data' : this.exportData});
            this.calcAvgRatingFilter(this.data)
            }
          },
          (error) => {
            console.error("API error, ", error);
          },
          () => {
            this.loading = false;
          }
        );
      }
    } catch (error) {
      console.error("Error while loading MyAppointmentByPage, ", error);
    }
  }
  AccountantFeedback(data){
    this.router.navigate(['/accountant/accountant-feedback',data.id]);
  }

  caClientFeedback(data){
    this.router.navigate(['/chiefaccountant/ca-client-feedback',data.id]);
  }

  MakeAppointmentRequestForAcc(data) {
      let decisionRef = this.dialog.open(AppointmentRequestComponent, {
        width: "32rem",
          data: {
            tempData : data
          },
      });
      return decisionRef;
  }

  MakeAppointmentRequestForCA(data) {

    let decisionRef = this.dialog.open(CaAppointmentRequestComponent, {
      width: "32rem",
        data: {
          tempData : data
        },
    });
    return decisionRef;
  }


  ngOnChanges(changes: SimpleChanges) {
  }
 

  selectedUser(user: any) {
    const maxSelectedUsers = 10;
    this.cd.detectChanges();
    this.isSelected = user.selected;
  
    if (this.isSelected && this.selectedUsers.length >= maxSelectedUsers) {
      const foundItem = this.data.find(x => x.id === user.id);
  
      if (foundItem) {
        foundItem.selected = false;
      }
  
      let message;
      this.translate
        .get(["LIMIT_EXCEED_TO_SELECT_USER"])
        .subscribe((translations) => {
          message = translations["LIMIT_EXCEED_TO_SELECT_USER"];
        });
  
      this.toastr.error(message, "");
    } else {
      if (this.isSelected) {
        this.selectedUsers.push(user);
      } else {
        const index = this.selectedUsers.findIndex(x => x.id == user.id)
        if (index !== -1) {
          this.selectedUsers.splice(index, 1);
        }
      }
  
      this.feedbackReqestData = this.selectedUsers;
      this.selUsersNewData = this.feedbackReqestData;
      this.feedbackRequest.emit({ data: this.feedbackReqestData });
      this.feedbackReqestData = [];
    }
  }
  
    
  employeeFeedBackDropDown() {
     this.broadCast
      .getEmployeeFeedMessage()
      .subscribe((message) => {
        if (message){
            let tempdata = [];
            let cloneData = this.cloneTableData
            if(cloneData) { 
              
              if(this.isComponent == 'ca-employee-returns' || this.isComponent == 'ca-employee-satisfaction') {
                tempdata = cloneData.filter(x => x.accName == message)
                
              }else if(this.isComponent == 'ca-accountant-performance-feedback'){
                tempdata = cloneData.filter(x => x.user.fullName  == message) 
                this.calculateTotalAvgRating(tempdata);
                this.data = tempdata
              }
              else{
                if(this.isComponent){
                  tempdata = cloneData.filter(x => x.user.fullName == message)
                }
                
              }
              if (this.isComponent !== 'ca-accountant-performance-feedback') {
                this.data = tempdata;
                // this.data = [...this.data];
                // this.loadExportData.emit({ 'data': this.data });
                this.calcAvgRatingFilter(this.data);
              }
            }
          } else {
            if(this.cloneTableData) {
              this.data = this.cloneTableData
              this.data = [...this.data]
              this.loadExportData.emit({'data' : this.data });
              if(this.isComponent === 'acc-indentify-customer-needs'){
                if(!this.fliterMyClientData){
                  this.data = this.myClientData
                  this.loadExportData.emit({ 'data': this.data });
                  this.calcAvgRatingFilter(this.data)
                }else{
                  this.data = this.allClientData
                  this.calcAvgRatingFilter(this.data)
                }
              }else if(this.isComponent === 'ca-accountant-performance-feedback'){
                this.calculateTotalAvgRating(this.data);
                this.loadExportData.emit({ 'data': this.data });
                
              }
              else{
                this.data = this.cloneTableData
                this.calcAvgRatingFilter(this.data)
              }
            }
          }

      });
    
  }

      
  titleFeedBackDropDown() {
    this.broadCast
     .getTitleFeedMessage()
     .subscribe((message) => {
       if (message){
           let tempdata = [];
           let cloneData = this.cloneTableData
           if(cloneData) { 
             
             if(this.isComponent == 'ca-annual-evaluation' || this.isComponent == 'ca-periodic-evaluation') {
               tempdata = cloneData.filter(x => x.title == message)
               
             }else{
               if(this.isComponent){
                 tempdata = cloneData.filter(x => x.user.fullName == message)
               }
               
             }
             this.data = tempdata
             this.data = [...this.data]
             this.loadExportData.emit({'data' : this.data });
             this.calcAvgRatingFilter(this.data);
           }
         } 
     });
   
 }

  custFilterFeedbackDropdown() {
    this.broadCast.getCustFilterFeedMessage().subscribe((message) => {
      const tempdata = this.filterDataByMessage(message);
      this.data = tempdata;
      

      
    });
  }
  
  toggleFeedbackData(){
    this.broadCast.getToggleFeedMessage().subscribe((message) => {
      this.fliterMyClientData = message;

      this.calFeedbackData(message);
    })
  }
  
  calFeedbackData(message){
    if(message){
      this.calcAvgRatingFilter(this.allClientData);
    }else{
      this.calcAvgRatingFilter(this.myClientData);
    }

  }
  
    filterDataByMessage(message: any){
      if (this.isComponent === 'acc-indentify-customer-needs') {
        this.cloneCustdata = this.fliterMyClientData ? this.allClientData : this.myClientData;
      } else {
        this.cloneCustdata = this.cloneTableData;
      }
    let filteredData = [];
  
    switch (message) {
      case 'Red (Low Rating)':
      case 'Rouge (note faible)':
        filteredData = this.cloneCustdata?.filter(x => x.lowestRating <= 5);
        break;
  
      case 'Orange (Moderate Rating)':
      case 'Orange (note modérée)':
        filteredData = this.cloneCustdata?.filter(x => x.lowestRating > 5.5 && x.lowestRating < 7);
        break;
  
      case 'Green (High Rating)':
      case 'Vert (note élevée)':
        filteredData = this.cloneCustdata?.filter(x => x.lowestRating >= 7);
        break;

      case 'Blue (High Rating)':
      case 'Bleu (Note élevée)' :
        filteredData = this.cloneCustdata?.filter(x => x.lowestRating >= 9);
        break;

      case 'Yellow (Moderate Rating)':
      case 'Jaune (Note modérée)' :
        filteredData = this.cloneCustdata?.filter(x => x.lowestRating >= 7  && x.lowestRating < 9)
        break;

      default:
        filteredData = this.cloneCustdata;
        break;
    }
    this.calcAvgRatingFilter(filteredData)
    return filteredData;
  }
  


  calcAvgRatingFilter(filterData){
    let rating = 0;
    let total = 0;
    let averageRating = 0
    if(filterData){
      filterData.forEach((x) => {
      rating = x.averageRating
      if(rating){
        total = rating + total
      }
      })
      averageRating =  total/filterData.length;
      this.totalAverageRating = Math.floor(averageRating);
      // this.totalAverageRating = averageRating;
      this.totalRecords = filterData.length;
    }
  }

  calculateTotalAvgRating(filterData) {
    let totalRating = 0;
    let totalCount = 0;
  
    if (filterData) {
      filterData.forEach((item) => {
        let itemTotalRating = 0;
        let itemCount = item.userFeedbackDetails.length;
        
        item.userFeedbackDetails.forEach((detail) => {
          itemTotalRating += detail.rating;
        });
  
        totalRating += itemTotalRating;
        totalCount += itemCount;
      });
  
      let averageRating = totalCount ? totalRating / totalCount : 0;
      this.totalAverageRating = Math.floor(averageRating);
      this.totalRecords = filterData.length;
    }
  }
  

  onChange($event: MatSlideToggleChange, data: any) {
    data.isAccontantAssign = $event.checked;
  
    if ($event.checked) {
      this.assignAccountants(event, data);
    } else {
      this.unAssignAccountant(event, data);
    }
  }
  
    unAssignAccountant(event : any , data : any){
      try {
        this.auth.deleteAssignAccountantToClient(data.id,this.currentUser.id).subscribe((res:any)=>{
          if(res.status == "SUCCESS"){
            this.toogleType.emit({event : false});
            const indexToRemove = this.selUsersNewData.findIndex(x => x.id === data.id);
            if (indexToRemove !== -1) {
              this.selUsersNewData.splice(indexToRemove, 1);
              this.changeSelectedUsers.emit({ event: false, data: this.selUsersNewData });
            }
            this.translate.get(['ACC_UNASSIGN_SUCCESS'])
            .subscribe(translation=>{
              this.message=translation['ACC_UNASSIGN_SUCCESS']
            });
            this.feedbackRequest.emit({ 'data': this.feedbackReqestData });
            this.selectedUsers = []
            this.toastr.success(this.message, "");
          }else{
            this.translate.get(['ACC_UNASSIGN_FAIL'])
            .subscribe(translation=>{
              this.message=translation['ACC_UNASSIGN_FAIL']
            });
            this.toastr.error(this.message, "");
          }
         
        });
      } catch (error) {
        console.log("Error")
      }
    }

    assignAccountants(event: any, data: any) {
      if (data.id != null) {  
        let userAccList = []

        let obj = {
          accountantId : this.currentUser.id,
          userId : data.id
        }
        userAccList.push(obj)
        this.auth.assignAccountants(data.id, userAccList).subscribe((response: any) => {
          if (response.status === "SUCCESS") {
            this.toogleType.emit({ event: true });
            this.translate.get(['ASSIGN_SUCCESS'])
            .subscribe(translation=>{
              this.message=translation['ASSIGN_SUCCESS']
            });
            this.toastr.success(this.message, "");
          } else {
            this.translate.get(['ASSIGN_FAIL'])
            .subscribe(translation=>{
              this.message=translation['ASSIGN_FAIL']
            });
            this.toastr.error(this.message, "");
          }
        });
      }
    }
    downloadEvaFeedbackPdf(data: any) {
      const link = document.createElement('a');
      link.href = data.feedbackPdfUrl;
      link.download = 'periodic_feedback.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    
  
 }